import React from "react";
import Chart from "react-apexcharts";
import { Spin } from "antd";

const InvoiceOutstandingBarChart = ({
	invoiceOutStandingData,
	customerOutstandingAvg,
	isOutStandingLoading,
	currency,
	isEmployee,
}) => {
	const months = invoiceOutStandingData.map((item) => item.month);
	const invoiceData = invoiceOutStandingData.map((item) => parseFloat(item.totalInvoice));
	const collectionData = invoiceOutStandingData.map((item) => parseFloat(item.totalCollection));
	const outstandingData = invoiceOutStandingData.map((item) => parseFloat(item.totalOutstanding));

	const options = {
		chart: {
			type: "line",
			toolbar: { show: false },
		},
		xaxis: {
			type: "category",
			categories: months,
		},
		plotOptions: {
			bar: {
				horizontal: false,
				columnWidth: "80%",
			},
		},
		stroke: {
			width: [0, 0, 0, 1.5, 1.5],
			curve: "straight",
			dashArray: [0, 0, 0, 4, 4],
		},
		dataLabels: {
			enabled: false,
		},
		legend: {
			position: "top",
			horizontalAlign: "left",
			fontSize: "12px",
			itemMargin: {
				horizontal: 10,
				vertical: 5,
			},
			markers: {
				width: 50,
				height: 8,
			},
		},
		colors: ["#87C5FC", "#1FE397", "#ACACAC", "#87C5FC", "#1FE397"],
		tooltip: {
			style: {
				fontSize: "12px",
				color: "#000",
			},
			theme: "light",
			custom: function ({ series, seriesIndex, dataPointIndex, w }) {
				const month = w.globals.labels[dataPointIndex];
				const value = series[seriesIndex][dataPointIndex];
				const unadjusted = invoiceOutStandingData[dataPointIndex].totalUnadjustedamt;

				const excludeUnadjusted = seriesIndex === 1 || seriesIndex === 2;

				let tooltipContent = `<div class="payment_custom_tooltip">
                            <span style="color: #ffff; font-weight: bold;">${month}</span><br/>
                            <span>${w.globals.seriesNames[seriesIndex]}: ${
								isEmployee ? "INR" : currency
							} ${value}</span><br/>`;
				if (!excludeUnadjusted) {
					tooltipContent += `<span>Unadjusted: ${isEmployee ? "INR" : currency} ${unadjusted}</span>`;
				}

				tooltipContent += `</div>`;

				return tooltipContent;
			},
		},
	};

	const series = [
		{
			name: "Invoice",
			type: "column",
			data: invoiceData,
		},
		{
			name: isEmployee ? "Collection" : "Payment",
			type: "column",
			data: collectionData,
		},
		{
			name: "O/S",
			type: "column",
			data: outstandingData,
		},
		{
			name: "Invoice Trend",
			type: "line",
			data: invoiceData,
		},
		{
			name: isEmployee ? "Collection Trend" : "Payment Trend",
			type: "line",
			data: collectionData,
		},
	];

	return (
		<div>
			<Spin size="large" spinning={isOutStandingLoading}>
				<Chart options={options} series={series} type="bar" height={350} />
			</Spin>
		</div>
	);
};

export default InvoiceOutstandingBarChart;
